import Vue from "vue";
import { API_ENDPOINTS, EMAIL_NOTIFICATION } from "../utils/constants";
const $axios = Vue.axios;

export default {
  namespaced: true,

  state: {
    locations: [],
    taskDueNotifications: [],
    isNotificationEnabled: false,
    availableNotifications: [],
    categories: [],
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_AVAILABLE_NOTIFICATIONS(state, notifications) {
      state.availableNotifications = notifications;
    },
    SET_NOTIFICATION_ENABLED(state, enabled) {
      state.isNotificationEnabled = enabled;
    },
    SET_LOCATIONS(state, locations) {
      state.locations = locations;
    },
    SET_ALL_CREATED_NOTIFICATIONS(state, notifications) {
      state.taskDueNotifications = notifications;
    },
  },
  actions: {
    async fetchAvailableNotifications({ commit }) {
      try {
        const response = await $axios.post(
          API_ENDPOINTS.GET_ALL_AVAILABLE_FEATURES_BY_TYPE,
          { type: "fbc" }
        );
        if (response?.data && Array.isArray(response?.data?.data)) {
          commit("SET_AVAILABLE_NOTIFICATIONS", response.data.data);
        } else {
          commit("SET_AVAILABLE_NOTIFICATIONS", []);
        }
      } catch (error) {
        console.error("Error fetching available notifications:", error);
        throw error;
      }
    },
    async fetchLocations({ commit }) {
      try {
        const locationResponse = await $axios.post(
          "/v2/financialclose/location/get"
        );
        if(locationResponse?.data?.status === 'success' && locationResponse?.data?.data){
          const locationList = locationResponse.data.data;
          commit("SET_LOCATIONS", locationList);
        }
      } catch (error) {
        commit("SET_LOCATIONS", []);
        throw new Error(`Failed to fetch locations - ${error?.message || ''}`)
      }
    },
    async fetchNotificationEnabled({ commit, rootState }) {
      try {
        const clientId = rootState.client;
        const response = await $axios.post(`/v2/client/get/${clientId}`);
        if (
          response?.data &&
          response?.data?.status === "success" &&
          response.data.data &&
          response.data.data.length
        ) {
          const enabled = response.data.data[0]?.schedulerEnabled;
          commit("SET_NOTIFICATION_ENABLED", enabled);
        } else {
          commit("SET_NOTIFICATION_ENABLED", false);
        }
      } catch (err) {
        commit("SET_NOTIFICATION_ENABLED", false);
      }
    },
    async fetchAllCreatedNotifications({ commit }) {
      try {
        const response = await $axios.post(
          API_ENDPOINTS.GET_NOTIFICATIONS_BY_TYPE,
          { type: "fbc" }
        );
        if (response?.data && Array.isArray(response?.data?.data)) {
          commit("SET_ALL_CREATED_NOTIFICATIONS", response.data.data);
          commit("SET_AVAILABLE_NOTIFICATIONS", response.data.data);
        }
      } catch (error) {
        throw new Error(`Failed to fetch all created notifications - ${error?.message || ''}`)
      }
    },
    async saveNotification({ dispatch, commit }, { type, payload }) {
      try {
        let endpoint = "";
        if (
          type === EMAIL_NOTIFICATION.FEATURE_TYPES.DUETODAY ||
          type === EMAIL_NOTIFICATION.FEATURE_TYPES.OVERDUE
        ) {
          endpoint = API_ENDPOINTS.CREATE_OR_UPDATE_TASK_DUE_NOTIFICATION;
        } else if (
          type === EMAIL_NOTIFICATION.FEATURE_TYPES.DASHBOARD ||
          type === EMAIL_NOTIFICATION.FEATURE_TYPES.TASK_OVERDUE
        ) {
          endpoint = API_ENDPOINTS.ADD_AND_UPDATE_ESCALATION_AND_DASHBOARD_NOTIFICATION;
        }

        if (!endpoint) {
          throw new Error("Invalid notification type");
        }

        const response = await $axios.post(endpoint, payload);
        if (response?.data?.status === "success") {
          await dispatch("fetchAllCreatedNotifications");
          commit("sbSuccess", response?.data?.message || "Notification saved successfully", { root: true });
        } else {
          throw new Error(
            response?.data?.message || "Failed to save notification"
          );
        }
      } catch (error) {
        console.error("[TaskDueNotifications]: Failed to save notification", error);
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to save notification";
        commit("sbError", errorMessage, { root: true });
        throw new Error(errorMessage);
      }
    },
    async fetchCategories({ commit }) {
      try {
        const response = await $axios.post(
          "/v2/financialclose/masters/chartofaccount/get"
        );
        if (response?.data?.status === "success") {
          const chartAcc = response.data.data || [];
          const categorySet = new Set();
          chartAcc.forEach((item) => {
            if (item?.category && typeof item.category === "string") {
              categorySet.add(item.category);
            }
          });
          const uniqueCategories = Array.from(categorySet).map((category) => ({
            id: category,
            name: category,
          }));
          commit("SET_CATEGORIES", uniqueCategories);
        } else {
          commit("SET_CATEGORIES", []);
        }
      } catch (error) {
        console.error(
          "[TaskDueNotifications]: Failed to fetch categories",
          error
        );
        commit("SET_CATEGORIES", []);
      }
    },
    async changeStatusForNotification({ dispatch }, { id, status }) {
      const response = await $axios.post(
        `${API_ENDPOINTS.CHANGE_NOTIFICATION_STATUS}/${id}`,
        {
          action: status,
        }
      );
      if (response?.data?.status !== "success") {
        throw new Error(response?.data?.message || "Failed to update status");
      }
      await dispatch("fetchAllCreatedNotifications");
    },
  },

  getters: {
    fetchNotificationEnabled(state) {
      return state?.isNotificationEnabled;
    },
    fetchAvailableNotifications(state) {
      return state?.availableNotifications ?? [];
    },
    fetchLocations(state) {
      return state?.locations ?? [];
    },
    fetchAllCreatedNotifications(state) {
      return state?.taskDueNotifications ?? [];
    },
    fetchCategories(state) {
      return state?.categories ?? [];
    },
  },
};
